import { render, staticRenderFns } from "./HomeRegionApplication.vue?vue&type=template&id=04c2a6a3&scoped=true"
import script from "./HomeRegionApplication.vue?vue&type=script&lang=js"
export * from "./HomeRegionApplication.vue?vue&type=script&lang=js"
import style0 from "./HomeRegionApplication.vue?vue&type=style&index=0&id=04c2a6a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c2a6a3",
  null
  
)

export default component.exports